import { Autoplay } from "swiper";
import Swiper from "swiper/bundle";

function initSwiper() {

    // Initialize Swiper with your desired options
    const swiper = new Swiper(".banner-slider-wrapper", {
        pagination: false,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 10000,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        }
    });

}

initSwiper();

